module.exports = __webpack_public_path__ + "0345e6d426cec05a2933090cc9de7d40.png";